
namespace Matrix.Dashboards {

    export interface IWidgetDesigner {
        init(dialog: IWidgetDesignerDialog);
        onLoad?();
        destroy();
    }
}